import React from 'react';
import { Box, Stack, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import EmptyState from './EmptyState';

export default function ResponsiveCardList({
  items = [],
  desktop,
  renderCard,
  emptyTitle = 'No records found',
  emptyDescription,
  breakpoint = 'md',
  spacing = 1.2,
  sx,
}) {
  const theme = useTheme();
  const desktopUp = useMediaQuery(theme.breakpoints.up(breakpoint));

  if (!items.length) {
    return <EmptyState compact title={emptyTitle} description={emptyDescription} />;
  }

  if (desktopUp && desktop) return desktop;

  return (
    <Stack spacing={spacing} sx={sx}>
      {items.map((item, index) => (
        <Box key={item?.id || item?.key || index}>{renderCard(item, index)}</Box>
      ))}
    </Stack>
  );
}
